import { render, staticRenderFns } from "./card_plus.vue?vue&type=template&id=0f126c86&scoped=true&"
import script from "./card_plus.vue?vue&type=script&lang=js&"
export * from "./card_plus.vue?vue&type=script&lang=js&"
import style0 from "./card_plus.vue?vue&type=style&index=0&id=0f126c86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f126c86",
  null
  
)

export default component.exports